import React, { useState, useRef, useCallback } from 'react';
import useListInfinite from '../../hooks/useListInfinite'
import './OrgPopup.css'


const OrgEventHistoryPopup = props => {
    const orgid = props.id
    const [query, setQuery] = useState({ sort: { field: 'createdAt', order: 'DESC' }, filter: { OrganizationId: orgid } })
    const [direction, setDirection] = useState('ASC')
    const [pageNumber, setPageNumber] = useState(1)
    const {
        items: events,
        hasMore,
        loading,
        error
    } = useListInfinite(query, pageNumber, 'Events')
    const observer = useRef()
    const lastItemElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 1)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore])

    let divs = [<div class="pop-row no-hover">
        <div class="pop-row-section pop-row-section-header no-hover">Time Stamp</div>
        <div class="pop-row-section pop-row-section-header no-hover">Message</div>
        <div class="pop-row-section pop-row-section-header no-hover">Zone ID</div>
    </div>]

    let fieldDivs = []
    if (events === null) console.log('no events')
    else fieldDivs = events.map((event, index) => {
        const localDate = new Date(event.createdAt).toString();
        if (events.length === index + 1) {
            return <div class="pop-row" style={{ minWidth: '520px' }} ref={lastItemElementRef} >
                <div class="pop-row-section" >{localDate}</div>
                <div class="pop-row-section" >{event.body}</div>
                <div class="pop-row-section" >{event.zone_id}</div>
            </div>
        } else {
            return <div class="pop-row" style={{ minWidth: '520px' }} >
                <div class="pop-row-section">{localDate}</div>
                <div class="pop-row-section">{event.body}</div>
                <div class="pop-row-section">{event.zone_id}</div>
            </div>
        }
    })

    divs.push(fieldDivs)

    return (<div>
        <div class="bg-overlay" onClick={props.onclickoutside} />
        <div class="org-popup">
            <div class="org-popup-title">
                Alert History
            </div>
            <div class="popup-table">
                {divs}
            </div>
        </div>
    </div>)
}

export default OrgEventHistoryPopup